export default __webpack_public_path__ + "static/media/ttfont_roman.56c5ec55.ttf";